
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"21","viewBox":"0 0 20 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2.80314 0C2.50777 0 2.26833 0.239445 2.26833 0.53481C2.26833 0.830174 2.50777 1.06962 2.80314 1.06962H9.19421L1.15664 9.10723C0.947786 9.31609 0.947786 9.65466 1.15664 9.86352C1.3655 10.0724 1.70412 10.0724 1.91298 9.86352L9.95057 1.82595V8.21609C9.95057 8.51145 10.19 8.7509 10.4854 8.7509C10.7807 8.7509 11.0202 8.51145 11.0202 8.21609V0.53481C11.0202 0.239445 10.7807 0 10.4854 0H2.80314ZM17.7811 20.0216C18.0765 20.0216 18.316 19.7821 18.316 19.4868C18.316 19.1914 18.0765 18.952 17.7811 18.952H11.3901L19.4276 10.9144C19.6365 10.7055 19.6365 10.3669 19.4276 10.1581C19.2188 9.9492 18.8802 9.9492 18.6713 10.1581L10.6337 18.1956V11.8055C10.6337 11.5101 10.3943 11.2707 10.0989 11.2707C9.80355 11.2707 9.5641 11.5101 9.5641 11.8055V19.4868C9.5641 19.7821 9.80355 20.0216 10.0989 20.0216H17.7811Z","fill":"#A1AAC6"}})])
          )
        }
      }
    